export enum ArchiveTitleRuleItemParamType {
  ITEM_SN = 'ITEM_SN',
  ITEM_NAME = 'ITEM_NAME',
}
